import React from 'react'

// size - oneOf 'button',...
const Loader = ({ size, style }) => (
    <div className="loader animate-appear" style={style}>
        <div className={`spinner size__${size}`} />
    </div>
)

export default Loader



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Loader.jsx